<template>
  <div class="container">
    <div class="mwow-detail-header">
      <div class="left">
        <div class="back-btn" @click="$router.go(-1)">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="mid">
        <p>我要提现</p>
      </div>
    </div>
    <div class="card-box">
      <div class="title">提现银行卡信息</div>
      <div class="flex card-info">
        <div class="flex card-title">
          <div>银行名称：</div>
          <div>{{ bankInfo.nbk_name }}</div>
        </div>
        <div class="flex card-number">
          <div>银行卡：</div>
          <div>{{ bankInfo.acct_no }}</div>
        </div>
      </div>
    </div>
    <el-form
      :model="bankInfo"
      class="form"
      label-width="100px"
      ref="mainForm"
      :rules="rules"
    >
      <!-- <el-form-item label="提现银行卡：" prop="withdrawalBank">
        <el-input
          v-model="bankInfo.withdrawalBank"
          placeholder="请输入提现银行卡"
          type="text"
          maxlength="99"
          disabled
        >
          <span slot="suffix" class="bank-icon">
            <i class="el-icon-question"></i>
            <span>工商银行</span>
          </span>
        </el-input>
        <span class="change-bank">
          更换银行卡
        </span>
      </el-form-item> -->
      <el-form-item label="提现金额：" prop="withdrawalAmount">
        <el-input
          v-model="bankInfo.withdrawalAmount"
          type="number"
          placeholder="请输入提现金额"
          @change="handleWithdrawalAmount"
          @input="handleWithdrawalAmountInput"
        ></el-input>
        <div class="real-withdrawal">
          <span>可提现金额：</span>
          <span class="green">{{ bankInfo.withdraw_able_amount }}元</span>
        </div>
      </el-form-item>
      <el-form-item label="手机号：" prop="mobile">
        <el-input
          type="tel"
          disabled
          v-model="bankInfo.mobile"
          placeholder="请输入手机号"
        ></el-input>
        <div class="real-withdrawal"></div>
      </el-form-item>
      <el-form-item label="验证码：" prop="code">
        <el-input
          v-model="bankInfo.code"
          type="number"
          placeholder="请输入验证码"
          @input="handleCodeInput"
        >
          <span slot="suffix" class="get-code">
            <span
              v-show="mobileCodeTimer === 0"
              v-debounce="1000"
              @click="hanldeGetCode"
              style="cursor: pointer"
              >获取验证码</span
            >
            <span v-show="mobileCodeTimer > 0">{{ mobileCodeTimer }}s</span>
          </span>
        </el-input>
        <div class="real-withdrawal"></div>
      </el-form-item>
      <el-form-item>
        <div
          class="mwow-button-filled success"
          v-debounce="1000"
          @click="handleSubmit"
        >
          确认提现
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { captcha } from "@/api/staff";
import {
  sendWithdrawApi,
  getMerchantInfoApi,
  withdrawalInfoApi,
  getAccountBalanceApi,
} from "@/api/storeWallet";
import { phonePass, pricePass, mobileCodePass } from "@/utils/rules";
export default {
  data() {
    return {
      activeName: "withdrawal",
      bankInfo: {
        withdrawalAmount: "",
        mobile: "",
        code: "",
        acct_no: "",
        nbk_name: "",
        withdraw_able_amount: "",
      },
      mobileCodeTimer: 0,
      rules: {
        // withdrawalBank: [{ required: true, message: "请输入提现银行卡", trigger: "blur" }],
        withdrawalAmount: [
          { validator: pricePass, trigger: "blur" },
          { required: true, message: "请输入提现金额", trigger: "blur" },
        ],
        mobile: [
          { validator: phonePass, trigger: "blur" },
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        code: [
          {
            validator: mobileCodePass,
            trigger: "blur",
          },
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.activeName = "withdrawal";
    getMerchantInfoApi().then((res) => {
      this.bankInfo.mobile = res.data.init_staff.mobile;
    });
    withdrawalInfoApi().then((res) => {
      this.bankInfo.acct_no = res.data.acct_no;
      this.bankInfo.nbk_name = res.data.nbk_name;
    });
    getAccountBalanceApi().then((res) => {
      this.bankInfo.withdraw_able_amount = res.data.withdraw_able_amount;
    });
  },
  methods: {
    handleBack() {
      this.$router.go(-1);
    },

    hanldeGetCode() {
      if (this.mobileCodeTimer > 0) {
        return false;
      }
      if (!this.bankInfo.mobile) {
        this.$message({
          type: "warning",
          message: "请先输入手机号",
        });
        return false;
      }
      captcha({
        mobile: String(this.bankInfo.mobile),
        event: "wallet_withdraw",
        area_code: "86",
      }).then((res) => {
        this.mobileCodeTimer = 60;
        const timer = setInterval(() => {
          this.mobileCodeTimer = this.mobileCodeTimer - 1;
          if (this.mobileCodeTimer === 0) {
            clearInterval(timer);
          }
        }, 1000);
      });
    },
    // 在输入时限制，只能输入两位小数
    handleWithdrawalAmountInput(evt) {
      let arr = [];
      if (evt.includes(".")) {
        arr = evt.split(".");
        arr[1] = arr[1].slice(0, 2);
        this.bankInfo.withdrawalAmount = arr.join(".");
      }
    },
    handleCodeInput(evt) {
      if (evt.length > 6) {
        this.bankInfo.code = evt.slice(0, 6);
        this.$message({
          type: "error",
          message: "请输入6位数字",
        });
      }
    },

    handleSubmit() {
      this.$refs["mainForm"].validate((valid) => {
        if (valid) {
          sendWithdrawApi({
            sms_code: String(this.bankInfo.code),
            draw_amount: String(this.bankInfo.withdrawalAmount),
          }).then(() => {
            this.$message({
              type: "success",
              message: "提交成功",
            });
            setTimeout(() => {
              this.$router.go(-1);
            }, 1500);
          });
        }
      });
    },
    handleWithdrawalAmount() {
      this.bankInfo.withdrawalAmount = Number(
        this.bankInfo.withdrawalAmount
      ).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
}
.card-box {
  width: 50%;
  margin: 20px auto;
  .title {
    font-size: 14px;
    font-weight: 700;
  }
  .card-info {
    margin: 15px 0;
    padding: 20px;
    background: #f6fafc;
    .card-title {
      flex: 1;
    }
    .card-number {
      flex: 1;
    }
  }
}
.form {
  width: 50%;
  margin: 0px auto;
  .change-bank {
    margin-left: 10px;
    color: #fc5e5e;
    cursor: pointer;
  }
  .bank-icon {
    padding-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 23px;
      width: 23px;
      margin-right: 5px;
    }
  }
  .get-code {
    padding: 0 12px;
    display: inline-block;
    color: #5c5d5e;
  }
  /deep/ .el-form-item__content {
    display: flex;
    .el-input {
      flex: 4;
      margin-right: 10px;
    }
    .real-withdrawal {
      flex: 1;
    }
  }
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-content: center;
}
.green {
  color: #07d1aa;
}
</style>
